import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { EnvironmentLoaderService } from '../services/environment-loader.service';
import { Router } from '@angular/router';

@Injectable()
export class ForbiddenInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap(
        () => {},
        (err: any) => {
          EnvironmentLoaderService;
          if (err instanceof HttpErrorResponse) {
            if (err.status === 403) {
              this.router.navigate(['forbidden']);
            }
            return;
          }
        }
      )
    );
  }
}
